import script from "./show-organization.vue?vue&type=script&setup=true&lang=js"
export * from "./show-organization.vue?vue&type=script&setup=true&lang=js"

import "./show-organization.vue?vue&type=style&index=0&id=7bfa84f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bfa84f7"]])

export default __exports__